import { Component, ElementRef, ViewChild } from '@angular/core';
import { ModalService } from '../../shared/modal.service'; // Adjust path if needed
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../assets/environments/environment';
import { HeaderComponent } from '../../shared/header/header.component';
import { QuotaComponent } from './quota/quota.component';
import { FooterComponent } from '../../shared/footer/footer.component';
// import { WhyBrandComponent } from './whyBrand/why-brand/why-brand.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { QuoteCardComponent } from '../../components/quote-card/quote-card.component';

@Component({
  selector: 'app-landing',
  imports: [
    FooterComponent,
    TranslateModule,
    FormsModule,
    CommonModule,
    QuotaComponent,
    HeaderComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent {
  direction: any;
  onContinue() {
    throw new Error('Method not implemented.');
  }
  phoneNumber: any;
  city: any;
  minDate: string = '';

  // Chat widget configuration
  chatWidgetEnvironment: 'production' | 'staging' = environment.name === 'stg' ? 'staging' : 'production';

  @ViewChild('quotaSection') quotaSection!: ElementRef;

  constructor(
    private modalService: ModalService, 
    private router: Router,
    private authService: AuthService
  ) {}

  authModalOpen = false;

  ngOnInit(): void {
    this.direction = document.documentElement.dir || 'ltr';
    this.minDate = new Date().toISOString().split('T')[0];
    
    // Don't redirect here - let app.component handle post-login redirect
    // The landing component shouldn't manage auth state redirects
    // This prevents redirect loops and conflicts with app.component logic
  }

  // Method to open the modal in Signup mode
  openSignup(): void {
    this.modalService.openModal('signup');
  }

  // You can decide which buttons trigger which mode
  openQuoteModal(): void {
    // Example: 'Get Quote Now' opens the Signup modal
    this.modalService.openModal('signup');
  }

  openLearnMoreModal(): void {
    // Example: 'Learn More' could also open Signup, or do something else
    this.modalService.openModal('signup');
  }

  handleAuthSuccess(user: any) {
    this.authModalOpen = false;
    if (user.isNew) {
      this.router.navigate(['/onboarding']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  scrollToQuota() {
    console.log('Scrolling to quota section');
    this.quotaSection.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}
